/**
 *  Bir projenin ana request atacağı servis base_url'i
 * @param {string} BASE_URL - API servisi BASE URL'i
 */
//export const BASE_URL = "http://192.168.1.98:9093";

export const BASE_URL = "https://api.rezzapp.com";
